import Compteur from "../../../../common/CarteLead/Compteur";
import TitreZone from "../../../../common/CarteLead/TitreZone";
import LeadAttachedDocument from "../../../SimplifiedFormListPage/SimplifiedFormItem/LeadAttachedDocument/LeadAttachedDocument";
import { libelleDevis } from "../LeadDocuments/libelleDocument";
import useLeadAutoItem from "../useLeadAutoItem";

export const TYPE_DEVIS_AUTO = "DEVIS_AUTO_PERCEVAL";

// Devis AUTO : les documents déposés (aperçu, téléchargement), un par
// compagnie quand l'agent a tarifé chez plusieurs (« Devis AssurAli »,
// « Devis Allianz (Prima) », PER-2500 ; un devis déposé à la main garde le nom
// de son fichier), et le dépôt d'un nouveau devis par un bouton ou en glissant
// un fichier sur la zone. Même composant qu'avant (notification du client,
// choix du produit).
const ZoneDevis = ({ canUpload }) => {
  const { leadAutoItem, actions } = useLeadAutoItem();
  const documents = (leadAutoItem.documents || []).map((d) => ({
    ...d,
    file: d.url,
    name: libelleDevis(d, d.nom),
    filename: d.nom,
    uploadedAt: d.ajouteLe,
  }));
  const nbDevis = documents.filter((d) => d.type === TYPE_DEVIS_AUTO).length;

  return (
    <section className="la-zone la-zone--devis" aria-label="Devis AUTO">
      <TitreZone icone="fa-file-invoice">
        Devis AUTO <Compteur plein={nbDevis > 0}>{nbDevis}</Compteur>
      </TitreZone>
      <LeadAttachedDocument
        compact
        emptyLabel="Aucun devis déposé."
        lead={{ ...leadAutoItem, documents }}
        uploadUrl={`new-leads/${leadAutoItem.id}/ajouter-document`}
        documentType={TYPE_DEVIS_AUTO}
        canUpload={canUpload}
        onUploadSuccess={actions.refreshLead}
        canNotify
      />
    </section>
  );
};

export default ZoneDevis;
